export const IMAGE_UPLOAD_FAILED_ACCEPT_MESSAGE = `This file type is not accepted. Accepted file types are JPEG and PNG.`
export const PSD_UPLOAD_FAILED_ACCEPT_MESSAGE = `This file type is not accepted. Only PSD (Photoshop) files can be uploaded.`
export const FILE_TOO_BIG_FAILED_ACCEPT_MESSAGE = `This image is too large. The maximum image size is 15MB`
